export function expensesForm(initialExpenses) {
    return {
        expenses: initialExpenses || [],
        addExpense() {
            this.expenses.push({ future_amount: '', month_no: '', description: '', frequency: '' });
        },
        removeExpense(index) {
            this.expenses.splice(index, 1);
        }
    }
}

export function loansForm(initialLoans) {
    return {
        loans: initialLoans || [],
        addLoan() {
            this.loans.push({ adt_balance: '', adt_payment: '', adt_rate: '', description: '' });
        },
        removeLoan(index) {
            this.loans.splice(index, 1);
        }
    }
}

export function incomesForm(initialIncomes) {
    return {
        incomes: initialIncomes || [],
        addIncome() {
            this.incomes.push({ future_amount: '', month_no: '', description: '', frequency: '' });
        },
        removeIncome(index) {
            this.incomes.splice(index, 1);
        }
    }
}

export function childrenForm(initialChildren) {
    return {
        children: initialChildren || [],
        addChild() {
            this.children.push({ name: '', birthday: '' });
        },
        removeChild(index) {
            this.children.splice(index, 1);
        }
    };
}

// Update the validation function
export function validateResetPasswordForm(form) {
    const newPassword = form.querySelector('#new_password').value;
    const confirmPassword = form.querySelector('#confirm_password').value;
    const passwordError = form.querySelector('#password-error');
    const confirmPasswordError = form.querySelector('#confirm-password-error');

    let isValid = true;

    // Reset error messages
    passwordError.textContent = '';
    confirmPasswordError.textContent = '';

    // Check password length
    if (newPassword.length < 8) {
        passwordError.textContent = 'Password must be at least 8 characters long.';
        isValid = false;
    }

    // Check if passwords match
    if (newPassword !== confirmPassword) {
        confirmPasswordError.textContent = 'Passwords do not match.';
        isValid = false;
    }

    return isValid;
}
